import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  type = 'website',
  image = 'https://customer-assets.emergentagent.com/job_a082ed2f-8c03-4839-8761-3a7d63d0c554/artifacts/ivgiip0b_fullsizeoutput_15a.jpeg',
  url
}) => {
  const siteTitle = 'Calling The Deep Counseling Services, LLC';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const siteUrl = process.env.REACT_APP_BACKEND_URL?.replace('/api', '') || 'https://callingthedeepcounseling.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteTitle} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional Meta Tags */}
      <meta name="author" content="Rhonda Zook, RN, MAMFT" />
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
